import teamConfig from "../../../utils/constants/teams";
import { scoreCardTranslationMap } from "../../../utils/translations";

const { warehouse } = teamConfig.teams;

export const drawerItemsMain = (usersTeam: string, isAdminOrOwner: boolean, isMobileDevice: boolean = false) => {
  return [
    {
      key: "Stocks",
      title: "stock",
      routes: [{ nav: "Stocks", routeName: "Stocks", title: "stock" }],
    },
    ...[
      usersTeam !== warehouse
        ? {
            key: "Production",
            title: "production",
            routes: [
              {
                nav: "ProductionStocks",
                routeName: "ProductionStocks",
                title: "productionStock",
              },
              {
                nav: "RawMaterialStocksOverView",
                routeName: "RawMaterialStocksOverView",
                title: "rawMaterialOverview",
              },
              {
                nav: "RawMaterialStocksDetails",
                routeName: "RawMaterialStocksDetails",
                title: "rawMaterialStock",
              },
            ],
          }
        : null,
    ],
    {
      key: "Warehouse",
      title: "warehouse",
      routes: [
        {
          nav: "WarehouseInventory",
          routeName: "WarehouseInventory",
          title: "inventoryOverview",
        },
        {
          nav: "WarehouseDetailsInventory",
          routeName: "WarehouseDetailsInventory",
          title: "inventoryDetail",
        },
      ],
    },
    ...[
      usersTeam !== warehouse
        ? {
            key: "Products",
            title: "searchProduct",
            routes: [
              { nav: "Products", routeName: "Products", title: "product" },
            ],
          }
        : null,
    ],
    ...[
      usersTeam !== warehouse
        ? {
            key: "CustomerStatus",
            title: "customerStatus",
            routes: [
              {
                nav: "CustomerStatus",
                routeName: "CustomerStatus",
                title: "customerStatus",
              },
            ],
          }
        : null,
    ],
    // {
    //   key: "DynamicWidthScreen",
    //   title: "Dynamic Width",
    //   routes: [
    //     {
    //       nav: "DynamicWidth",
    //       routeName: "DynamicWidth",
    //       title: "Dynamic Width",
    //     },
    //   ],
    // },
    // ...[
    //   usersTeam !== warehouse
    //     ? {
    //         key: "CustomerOrder",
    //         title: "Customer Order",
    //         routes: [{ nav: "CustomerOrder", routeName: "CustomerOrder", title: "Customer Order" }],
    //       }
    //     : null,
    // ],
    ...(isAdminOrOwner && !isMobileDevice
      ? [
          {
            key: "SalesScorecard",
            title: "Sales Scorecard",
            routes: [
              { nav: "SalesScorecard",      routeName: "SalesScorecard",      title: scoreCardTranslationMap["Dashboard"] },
              { nav: "UsageSalesScorecard", routeName: "UsageSalesScorecard", title: scoreCardTranslationMap["Usage"] },
              { nav: "ValueSalesScorecard", routeName: "ValueSalesScorecard", title: scoreCardTranslationMap["Value"] },
              { nav: "InvoiceDNDetail",     routeName: "InvoiceDNDetail",     title: scoreCardTranslationMap["InvoiceDN"] },
            ],
          },
        ]
      : []),
  ];
};
